export default { 
    i18nKey: 'persona3',
    firstName: 'Hannah',
    lastName: 'Reynolds',
    personaPrefix: 'HR_',
    image: '../assets/img/Persona3.jpg',
    index: 2,
    videoPrefix: 'HR-',
    personaDataAction: 'HR Team'   
}